import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import('@/components/Home')
const Calender = () => import('@/components/Calender')
const Profile = () => import('@/components/User/Profile')
const EditProfile = () => import('@/components/User/EditProfile')
const Messages = () => import('@/components/User/Messages')
const Search = () => import('@/components/Contacts/Search')
const Signup = () => import('@/components/User/Signup')
const Signin = () => import('@/components/User/Signin')
const Project = () => import('@/components/Projects/ProjectGrid')
const newProject = () => import('@/components/Projects/Projectdiag')
const projPage = () => import('@/components/Projects/ProjectPage')
const libPage = () => import('@/components/Library')
import AuthGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Project,
      beforeEnter: AuthGuard
    },
    {
      path: '/library',
      name: 'Library',
      component: libPage,
      beforeEnter: AuthGuard
    },
    {
      path: '/calender',
      name: 'Calender',
      component: Calender,
      beforeEnter: AuthGuard
    },
    {
      path: '/profile/:id',
      name: 'Profile',
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: '/project/:id',
      name: 'Project',
      component: projPage,
      beforeEnter: AuthGuard
    },
    {
      path: '/editprofile',
      name: 'EditProfile',
      component: EditProfile,
      beforeEnter: AuthGuard
    },
    {
      path: '/messages',
      name: 'Messages',
      component: Messages,
      beforeEnter: AuthGuard
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      beforeEnter: AuthGuard
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/newProject',
      name: 'AddProject',
      component: newProject,
      beforeEnter: AuthGuard
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js